export const backgroundImages = {
  desktop_bg: require('@/assets/desktop/desktop_bg.jpg'),

  // 认识手机，圆形加号
  yaddIndex4: require('@/assets/recognize/icon/yadd/4.jpg'),
  yaddIndex5: require('@/assets/recognize/icon/yadd/5.jpg'),
  yaddIndex6: require('@/assets/recognize/icon/yadd/6.jpg'),
  yaddIndex7: require('@/assets/recognize/icon/yadd/7.jpg'),
  yaddIndex8: require('@/assets/recognize/icon/yadd/8.jpg'),

  // 认识手机，方形加号
  faddIndex2: require('@/assets/recognize/icon/fadd/2.jpg'),
  faddIndex3: require('@/assets/recognize/icon/fadd/3.jpg'),
  faddIndex4: require('@/assets/recognize/icon/fadd/4.jpg'),
  faddIndex5: require('@/assets/recognize/icon/fadd/5.jpg'),

  // 认识手机，消息符号
  messageIndex2: require('@/assets/recognize/icon/message/2.jpg'),
  messageIndex3: require('@/assets/recognize/icon/message/3.jpg'),
  messageIndex4: require('@/assets/recognize/icon/message/4.jpg'),
  messageIndex5: require('@/assets/recognize/icon/message/5.jpg'),

  // 认识手机，定位图标
  positionIndex2: require('@/assets/recognize/icon/position/2.jpg'),
  positionIndex3: require('@/assets/recognize/icon/position/3.jpg'),
  positionIndex4: require('@/assets/recognize/icon/position/4.jpg'),
  positionIndex5: require('@/assets/recognize/icon/position/5.jpg'),
  positionIndex6: require('@/assets/recognize/icon/position/6.jpg'),

  // 认识手机，二维码符号
  QRcodeIndex2: require('@/assets/recognize/icon/QRcode/2.jpg'),
  QRcodeIndex3: require('@/assets/recognize/icon/QRcode/3.jpg'),
  QRcodeIndex4: require('@/assets/recognize/icon/QRcode/4.jpg'),
  QRcodeIndex5: require('@/assets/recognize/icon/QRcode/5.jpg'),

  // 认识手机，二维码符号
  scanCodeIndex2: require('@/assets/recognize/icon/scanCode/2.jpg'),
  scanCodeIndex3: require('@/assets/recognize/icon/scanCode/3.jpg'),
  scanCodeIndex4: require('@/assets/recognize/icon/scanCode/4.jpg'),
  scanCodeIndex5: require('@/assets/recognize/icon/scanCode/5.jpg'),
  scanCodeIndex6: require('@/assets/recognize/icon/scanCode/6.jpg'),

  // 认识手机，语音符号
  voiceIndex2: require('@/assets/recognize/icon/voice/2.jpg'),
  voiceIndex3: require('@/assets/recognize/icon/voice/3.jpg'),
  voiceIndex4: require('@/assets/recognize/icon/voice/4.jpg'),
  voiceIndex5: require('@/assets/recognize/icon/voice/5.jpg'),
  voiceIndex6: require('@/assets/recognize/icon/voice/6.jpg'),
  voiceIndex7: require('@/assets/recognize/icon/voice/7.jpg'),
  voiceIndex9: require('@/assets/recognize/icon/voice/9.jpg'),
  voiceIndex10: require('@/assets/recognize/icon/voice/10.jpg'),
  voiceIndex11: require('@/assets/recognize/icon/voice/11.jpg'),

  // 认识手机，导航符号
  navigationIndex0: require('@/assets/recognize/icon/navigation/1.png'),
  navigationIndex1: require('@/assets/recognize/icon/navigation/1-1.png'),
  navigationIndex2: require('@/assets/recognize/icon/navigation/2.jpg'),
  navigationIndex3: require('@/assets/recognize/icon/navigation/3.jpg'),
  navigationIndex4: require('@/assets/recognize/icon/navigation/4.jpg'),
  navigationIndex5: require('@/assets/recognize/icon/navigation/5.jpg'),
  navigationIndex6: require('@/assets/recognize/icon/navigation/7.jpg'),
  navigationIndex7: require('@/assets/recognize/icon/navigation/9.jpg'),
  navigationIndex8: require('@/assets/recognize/icon/navigation/11.jpg'),
  navigationIndex9: require('@/assets/recognize/icon/navigation/13.jpg'),
  navigationIndex10: require('@/assets/recognize/icon/navigation/14.jpg'),

  // 认识手机，打车符号
  carIndex2: require('@/assets/recognize/icon/car/2.jpg'),
  carIndex3: require('@/assets/recognize/icon/car/3.jpg'),
  carIndex4: require('@/assets/recognize/icon/car/4.jpg'),
  carIndex5: require('@/assets/recognize/icon/car/5.jpg'),
  carIndex6: require('@/assets/recognize/icon/car/7.jpg'),
  carIndex7: require('@/assets/recognize/icon/car/9.jpg'),
  carIndex8: require('@/assets/recognize/icon/car/10.jpg'),
  carIndex9: require('@/assets/recognize/icon/car/11.jpg'),
  carIndex10: require('@/assets/recognize/icon/car/12.jpg'),

  // 认识手机，人脸识别
  faceIndex2: require('@/assets/recognize/icon/face/2.jpg'),
  faceIndex3: require('@/assets/recognize/icon/face/3.jpg'),
  faceIndex4: require('@/assets/recognize/icon/face/4.jpg'),
  faceIndex5: require('@/assets/recognize/icon/face/6.jpg'),
  faceIndex6: require('@/assets/recognize/icon/face/8.jpg'),
  faceIndex7: require('@/assets/recognize/icon/face/9.jpg'),

  // 认识手机，表情包
  expressionIconIndex1: require('@/assets/recognize/icon/expression/2.jpg'),
  expressionIconIndex2: require('@/assets/recognize/icon/expression/3.jpg'),
  expressionIconIndex3: require('@/assets/recognize/icon/expression/4.jpg'),
  expressionIconIndex4: require('@/assets/recognize/icon/expression/5.jpg'),
  expressionIconIndex5: require('@/assets/recognize/icon/expression/7.jpg'),
  expressionIconIndex6: require('@/assets/recognize/icon/expression/9.jpg'),

  // 认识手机，设置符号
  setIndex2: require('@/assets/recognize/icon/set/2.jpg'),
  setIndex3: require('@/assets/recognize/icon/set/3.jpg'),
  setIndex4: require('@/assets/recognize/icon/set/4.jpg'),
  setIndex5: require('@/assets/recognize/icon/set/5.jpg'),
  setIndex6: require('@/assets/recognize/icon/set/6.jpg'),

  // 认识手机，返回符号
  returnIndex1: require('@/assets/recognize/icon/return/2.jpg'),
  returnIndex2: require('@/assets/recognize/icon/return/3.jpg'),
  returnIndex3: require('@/assets/recognize/icon/return/4.jpg'),
  returnIndex4: require('@/assets/recognize/icon/return/6.jpg'),

  // 认识手机，关闭符号
  closeIndex2: require('@/assets/recognize/icon/close/2.jpg'),
  closeIndex3: require('@/assets/recognize/icon/close/3.jpg'),
  closeIndex4: require('@/assets/recognize/icon/close/4.jpg'),
  closeIndex5: require('@/assets/recognize/icon/close/5.jpg'),
  closeIndex7: require('@/assets/recognize/icon/close/7.jpg'),

  // 认识手机，拍照符号
  photoIndex2: require('@/assets/recognize/icon/photo/2.jpg'),
  photoIndex3: require('@/assets/recognize/icon/photo/3.jpg'),
  photoIndex4: require('@/assets/recognize/icon/photo/4.jpg'),
  photoIndex6: require('@/assets/recognize/icon/photo/6.jpg'),

  // 认识手机，客服符号
  serviceIndex2: require('@/assets/recognize/icon/service/2.jpg'),
  serviceIndex3: require('@/assets/recognize/icon/service/3.jpg'),
  serviceIndex4: require('@/assets/recognize/icon/service/4.jpg'),
  serviceIndex5: require('@/assets/recognize/icon/service/6.jpg'),
  serviceIndex6: require('@/assets/recognize/icon/service/8.jpg'),
  serviceIndex7: require('@/assets/recognize/icon/service/12.jpg'),
  serviceIndex8: require('@/assets/recognize/icon/service/13.jpg'),

  // 认识手机，搜索符号
  searchIndex2: require('@/assets/recognize/icon/search/2.jpg'),
  searchIndex3: require('@/assets/recognize/icon/search/3.jpg'),
  searchIndex4: require('@/assets/recognize/icon/search/4.jpg'),
  searchIndex5: require('@/assets/recognize/icon/search/5.jpg'),
  searchIndex6: require('@/assets/recognize/icon/search/6.jpg'),
  searchIndex7: require('@/assets/recognize/icon/search/7.jpg'),

  // 认识手机，购物车
  shoppingCartIndex2: require('@/assets/recognize/icon/shoppingCart/2.jpg'),
  shoppingCartIndex3: require('@/assets/recognize/icon/shoppingCart/3.jpg'),
  shoppingCartIndex4: require('@/assets/recognize/icon/shoppingCart/4.jpg'),
  shoppingCartIndex5: require('@/assets/recognize/icon/shoppingCart/5.jpg'),
  shoppingCartIndex6: require('@/assets/recognize/icon/shoppingCart/6.jpg'),
  shoppingCartIndex7: require('@/assets/recognize/icon/shoppingCart/7.jpg'),

  // 认识手机，个人中心
  useIndex2: require('@/assets/recognize/icon/use/2.jpg'),
  useIndex3: require('@/assets/recognize/icon/use/3.jpg'),
  useIndex4: require('@/assets/recognize/icon/use/4.jpg'),
  useIndex5: require('@/assets/recognize/icon/use/5.jpg'),

  // 认识手机，点赞
  loveIndex2: require('@/assets/recognize/icon/love/2.jpg'),
  loveIndex3: require('@/assets/recognize/icon/love/3.jpg'),
  loveIndex4: require('@/assets/recognize/icon/love/4.jpg'),
  loveIndex5: require('@/assets/recognize/icon/love/5.jpg'),
  loveIndex7: require('@/assets/recognize/icon/love/7.jpg'),
  loveIndex8: require('@/assets/recognize/icon/love/8.jpg'),
  loveIndex9: require('@/assets/recognize/icon/love/9.jpg'),
  loveIndex10: require('@/assets/recognize/icon/love/10.jpg'),

  // 认识手机，分享符号
  shareIndex2: require('@/assets/recognize/icon/share/2.jpg'),
  shareIndex3: require('@/assets/recognize/icon/share/3.jpg'),
  shareIndex4: require('@/assets/recognize/icon/share/4.jpg'),
  shareIndex5: require('@/assets/recognize/icon/share/5.jpg'),
  // 认识手机，收藏符号
  collectIndex2: require('@/assets/recognize/icon/collect/2.jpg'),
  collectIndex3: require('@/assets/recognize/icon/collect/3.jpg'),
  collectIndex4: require('@/assets/recognize/icon/collect/4.jpg'),
  collectIndex5: require('@/assets/recognize/icon/collect/5.jpg'),

  // 认识手机，呼叫符号
  callIndex2: require('@/assets/recognize/icon/call/2.jpg'),
  callIndex3: require('@/assets/recognize/icon/call/3.jpg'),
  callIndex4: require('@/assets/recognize/icon/call/4.jpg'),
  callIndex5: require('@/assets/recognize/icon/call/5.jpg'),
  callIndex6: require('@/assets/recognize/icon/call/6.jpg'),
  callIndex7: require('@/assets/recognize/icon/call/7.jpg'),

  // 认识组件，选项卡
  tabIndex2: require('@/assets/recognize/module/tab/2.jpg'),
  tabIndex3: require('@/assets/recognize/module/tab/3.jpg'),
  tabIndex4: require('@/assets/recognize/module/tab/4.jpg'),
  tabIndex5: require('@/assets/recognize/module/tab/5.jpg'),
  tabIndex6: require('@/assets/recognize/module/tab/6.jpg'),
  tabIndex7: require('@/assets/recognize/module/tab/7.jpg'),

  // 认识组件，标签
  labelIndex2: require('@/assets/recognize/module/label/2.jpg'),
  labelIndex3: require('@/assets/recognize/module/label/3.jpg'),
  labelIndex4: require('@/assets/recognize/module/label/4.jpg'),
  labelIndex5: require('@/assets/recognize/module/label/5.jpg'),

  // 认识组件，多选
  checkboxIndex2: require('@/assets/recognize/module/checkbox/2.jpg'),
  checkboxIndex3: require('@/assets/recognize/module/checkbox/3.jpg'),
  checkboxIndex4: require('@/assets/recognize/module/checkbox/4.jpg'),
  checkboxIndex5: require('@/assets/recognize/module/checkbox/5.jpg'),
  checkboxIndex6: require('@/assets/recognize/module/checkbox/6.jpg'),
  checkboxIndex7: require('@/assets/recognize/module/checkbox/7.jpg'),
  checkboxIndex9: require('@/assets/recognize/module/checkbox/9.jpg'),

  // 认识组件，滑动切换
  sliderSwitchIndex2: require('@/assets/recognize/module/sliderSwitch/2.jpg'),
  sliderSwitchIndex3: require('@/assets/recognize/module/sliderSwitch/3.jpg'),
  sliderSwitchIndex4: require('@/assets/recognize/module/sliderSwitch/4.jpg'),
  sliderSwitchIndex5: require('@/assets/recognize/module/sliderSwitch/5.jpg'),

  // 认识组件，单选
  radioIndex2: require('@/assets/recognize/module/radio/2.jpg'),
  radioIndex3: require('@/assets/recognize/module/radio/3.jpg'),
  radioIndex4: require('@/assets/recognize/module/radio/4.jpg'),
  radioIndex5: require('@/assets/recognize/module/radio/5.jpg'),
  radioIndex6: require('@/assets/recognize/module/radio/6.jpg'),

  // 认识组件，数字选择器
  inputNumberIndex2: require('@/assets/recognize/module/inputNumber/2.jpg'),
  inputNumberIndex3: require('@/assets/recognize/module/inputNumber/3.jpg'),
  inputNumberIndex4: require('@/assets/recognize/module/inputNumber/4.jpg'),
  inputNumberIndex5: require('@/assets/recognize/module/inputNumber/5.jpg'),

  // 认识组件，滑块
  sliderIndex2: require('@/assets/recognize/module/slider/2.jpg'),
  sliderIndex3: require('@/assets/recognize/module/slider/3.jpg'),
  sliderIndex4: require('@/assets/recognize/module/slider/4.jpg'),
  sliderIndex5: require('@/assets/recognize/module/slider/6.jpg'),
  sliderIndex6: require('@/assets/recognize/module/slider/8.jpg'),

  // 认识组件，下拉
  selectIndex2: require('@/assets/recognize/module/select/2.jpg'),
  selectIndex3: require('@/assets/recognize/module/select/3.jpg'),
  selectIndex4: require('@/assets/recognize/module/select/4.jpg'),
  selectIndex5: require('@/assets/recognize/module/select/6.jpg'),

  // 认识组件，开关
  switchIndex2: require('@/assets/recognize/module/switch/2.jpg'),
  switchIndex3: require('@/assets/recognize/module/switch/3.jpg'),
  switchIndex4: require('@/assets/recognize/module/switch/4.jpg'),
  switchIndex5: require('@/assets/recognize/module/switch/6.jpg'),

  // 认识组件，小程序
  appletIndex2: require('@/assets/recognize/module/applet/2.jpg'),
  appletIndex3: require('@/assets/recognize/module/applet/3.jpg'),
  appletIndex4: require('@/assets/recognize/module/applet/4.jpg'),
  appletIndex5: require('@/assets/recognize/module/applet/6.jpg'),

  // 认识组件，数字验证码
  codeIndex2: require('@/assets/recognize/module/code/2.jpg'),
  codeIndex3: require('@/assets/recognize/module/code/3.jpg'),
  codeIndex4: require('@/assets/recognize/module/code/4.jpg'),
  codeIndex5: require('@/assets/recognize/module/code/5.jpg'),
  codeIndex6: require('@/assets/recognize/module/code/7.jpg'),
  codeIndex7: require('@/assets/recognize/module/code/9.jpg'),

  // 认识组件，语音组件
  soundsIndex2: require('@/assets/recognize/module/sounds/2.jpg'),
  soundsIndex3: require('@/assets/recognize/module/sounds/3.jpg'),
  soundsIndex4: require('@/assets/recognize/module/sounds/4.jpg'),
  soundsIndex5: require('@/assets/recognize/module/sounds/5.jpg'),
  soundsIndex6: require('@/assets/recognize/module/sounds/7.jpg'),
  soundsIndex7: require('@/assets/recognize/module/sounds/9.jpg'),

  // 认识页面，认识首页
  // recognizeHome2: require('@/assets/recognize/page/home/2.jpg'),
  // recognizeHome3: require('@/assets/recognize/page/home/3.jpg'),
  // recognizeHome4: require('@/assets/recognize/page/home/4.jpg'),
  // recognizeHome5: require('@/assets/recognize/page/home/5.jpg'),
  // recognizeHome6: require('@/assets/recognize/page/home/6.jpg'),
  // recognizeHome7: require('@/assets/recognize/page/home/7.jpg'),
  // recognizeHome8: require('@/assets/recognize/page/home/8.jpg'),
  // recognizeHome9: require('@/assets/recognize/page/home/9.jpg'),
  // recognizeHome10: require('@/assets/recognize/page/home/10.jpeg'),
  // recognizeHome11: require('@/assets/recognize/page/home/11.jpg'),

  // 认识页面，下拉页面
  dropDownIndex2: require('@/assets/recognize/page/dropDown/2.jpg'),
  dropDownIndex3: require('@/assets/recognize/page/dropDown/3.jpg'),
  dropDownIndex4: require('@/assets/recognize/page/dropDown/4.jpg'),
  dropDownIndex5: require('@/assets/recognize/page/dropDown/5.jpg'),

  // 认识页面，弹窗页面
  popupIndex2: require('@/assets/recognize/page/popup/2.jpg'),
  popupIndex3: require('@/assets/recognize/page/popup/3.jpg'),
  popupIndex4: require('@/assets/recognize/page/popup/4.jpg'),
  popupIndex5: require('@/assets/recognize/page/popup/5.jpg'),
  popupIndex6: require('@/assets/recognize/page/popup/6.jpg'),
  popupIndex7: require('@/assets/recognize/page/popup/7.jpg'),

  // 认识页面，聊天信息页面
  chatMessageIndex2: require('@/assets/recognize/page/chatMessage/2.jpg'),
  chatMessageIndex3: require('@/assets/recognize/page/chatMessage/3.jpg'),
  chatMessageIndex4: require('@/assets/recognize/page/chatMessage/4.jpg'),
  chatMessageIndex5: require('@/assets/recognize/page/chatMessage/5.jpg'),
  chatMessageIndex6: require('@/assets/recognize/page/chatMessage/6.jpg'),
  chatMessageIndex7: require('@/assets/recognize/page/chatMessage/7.jpg'),
  chatMessageIndex8: require('@/assets/recognize/page/chatMessage/8.jpg'),
  chatMessageIndex9: require('@/assets/recognize/page/chatMessage/9.jpg'),

  // 认识页面，社交圈页面
  socialCircleIndex2: require('@/assets/recognize/page/socialCircle/2.jpg'),
  socialCircleIndex3: require('@/assets/recognize/page/socialCircle/3.jpg'),
  socialCircleIndex4: require('@/assets/recognize/page/socialCircle/4.jpg'),
  socialCircleIndex5: require('@/assets/recognize/page/socialCircle/5.jpg'),
  socialCircleIndex6: require('@/assets/recognize/page/socialCircle/6.jpg'),

  // 认识页面，聊天窗口页面
  chatWindowIndex2: require('@/assets/recognize/page/chatWindow/2.jpg'),
  chatWindowIndex3: require('@/assets/recognize/page/chatWindow/3.jpg'),
  chatWindowIndex4: require('@/assets/recognize/page/chatWindow/4.jpg'),
  chatWindowIndex5: require('@/assets/recognize/page/chatWindow/5.jpg'),
  chatWindowIndex6: require('@/assets/recognize/page/chatWindow/6.jpg'),

  // 认识页面，首页
  homePageIndex2: require('@/assets/recognize/page/homePage/2.jpg'),
  homePageIndex3: require('@/assets/recognize/page/homePage/3.jpg'),
  homePageIndex4: require('@/assets/recognize/page/homePage/4.jpg'),
  homePageIndex5: require('@/assets/recognize/page/homePage/5.jpg'),
  homePageIndex6: require('@/assets/recognize/page/homePage/6.jpg'),
  homePageIndex7: require('@/assets/recognize/page/homePage/7.jpg'),
  homePageIndex8: require('@/assets/recognize/page/homePage/8.jpg'),
  homePageIndex9: require('@/assets/recognize/page/homePage/9.jpg'),
  homePageIndex10: require('@/assets/recognize/page/homePage/10.jpg'),

  // 认识页面，登录页面
  loginIndex2: require('@/assets/recognize/page/login/2.jpg'),
  loginIndex3: require('@/assets/recognize/page/login/3.jpg'),
  loginIndex4: require('@/assets/recognize/page/login/4.jpg'),
  loginIndex5: require('@/assets/recognize/page/login/5.jpg'),
  loginIndex6: require('@/assets/recognize/page/login/6.jpg'),
  loginIndex7: require('@/assets/recognize/page/login/7.jpg'),
  loginIndex8: require('@/assets/recognize/page/login/8.jpg'),

  // 认识页面，内容列表页面
  contentListIndex2: require('@/assets/recognize/page/contentList/2.jpg'),
  contentListIndex3: require('@/assets/recognize/page/contentList/3.jpg'),
  contentListIndex4: require('@/assets/recognize/page/contentList/4.jpg'),
  contentListIndex5: require('@/assets/recognize/page/contentList/5.jpg'),
  contentListIndex6: require('@/assets/recognize/page/contentList/6.jpg'),
  contentListIndex7: require('@/assets/recognize/page/contentList/7.jpg'),

  // 认识页面，内容详情页面
  contentDetailsIndex2: require('@/assets/recognize/page/contentDetails/2.jpg'),
  contentDetailsIndex3: require('@/assets/recognize/page/contentDetails/3.jpg'),
  contentDetailsIndex4: require('@/assets/recognize/page/contentDetails/4.jpg'),
  contentDetailsIndex5: require('@/assets/recognize/page/contentDetails/5.jpg'),

  // 认识页面，个人中心页面
  personalCenterIndex2: require('@/assets/recognize/page/personalCenter/2.jpg'),
  personalCenterIndex3: require('@/assets/recognize/page/personalCenter/3.jpg'),
  personalCenterIndex4: require('@/assets/recognize/page/personalCenter/4.jpg'),
  personalCenterIndex5: require('@/assets/recognize/page/personalCenter/5.jpg'),
  personalCenterIndex6: require('@/assets/recognize/page/personalCenter/6.jpg'),

  // 认识页面，购物车页面
  pageShoppingCartIndex2: require('@/assets/recognize/page/shoppingCart/2.jpg'),
  pageShoppingCartIndex3: require('@/assets/recognize/page/shoppingCart/3.jpg'),
  pageShoppingCartIndex4: require('@/assets/recognize/page/shoppingCart/4.jpg'),
  pageShoppingCartIndex5: require('@/assets/recognize/page/shoppingCart/5.jpg'),
  pageShoppingCartIndex6: require('@/assets/recognize/page/shoppingCart/6.jpg'),
  pageShoppingCartIndex7: require('@/assets/recognize/page/shoppingCart/7.jpg'),

  // 认识页面，订单确认页面
  orderConfirmationIndex2: require('@/assets/recognize/page/orderConfirmation/2.jpg'),
  orderConfirmationIndex3: require('@/assets/recognize/page/orderConfirmation/3.jpg'),
  orderConfirmationIndex4: require('@/assets/recognize/page/orderConfirmation/4.jpg'),
  orderConfirmationIndex5: require('@/assets/recognize/page/orderConfirmation/5.jpg'),
  orderConfirmationIndex6: require('@/assets/recognize/page/orderConfirmation/6.jpg'),
  orderConfirmationIndex7: require('@/assets/recognize/page/orderConfirmation/7.jpg'),

  // 认识页面，订单详情页面
  orderDetailsIndex2: require('@/assets/recognize/page/orderDetails/2.jpg'),
  orderDetailsIndex3: require('@/assets/recognize/page/orderDetails/3.jpg'),
  orderDetailsIndex4: require('@/assets/recognize/page/orderDetails/4.jpg'),
  orderDetailsIndex5: require('@/assets/recognize/page/orderDetails/5.jpg'),
  orderDetailsIndex6: require('@/assets/recognize/page/orderDetails/6.jpg'),
  orderDetailsIndex7: require('@/assets/recognize/page/orderDetails/7.jpg'),

  // 设置闹钟，主流程图片
  alarmClockIndex2: require('@/assets/use/alarmClock/1-2.jpg'),
  alarmClockIndex3: require('@/assets/use/alarmClock/1-3.jpg'),
  alarmClockIndex4: require('@/assets/use/alarmClock/1-4.jpg'),
  alarmClockIndex5: require('@/assets/use/alarmClock/1-5.jpg'),
  alarmClockIndex6: require('@/assets/use/alarmClock/1-6.jpg'),
  alarmClockIndex7: require('@/assets/use/alarmClock/1-7.jpg'),
  alarmClockIndex8: require('@/assets/use/alarmClock/1-8.jpg'),
  alarmClockIndex9: require('@/assets/use/alarmClock/1-9.jpg'),
  alarmClockIndex10: require('@/assets/use/alarmClock/1-10.jpg'),
  alarmClockIndex11: require('@/assets/use/alarmClock/1-11.jpg'),
  alarmClockIndex12: require('@/assets/use/alarmClock/1-12.jpg'),
  alarmClockIndex13: require('@/assets/use/alarmClock/1-13.jpg'),
  alarmClockIndex14: require('@/assets/use/alarmClock/1-14.jpg'),

  // 黑名单，主流程图片
  blacklistIndex2: require('@/assets/use/blacklist/1-2.jpg'),
  blacklistIndex3: require('@/assets/use/blacklist/1-3.jpg'),
  blacklistIndex4: require('@/assets/use/blacklist/1-4.jpg'),
  blacklistIndex5: require('@/assets/use/blacklist/1-5.jpg'),
  blacklistIndex6: require('@/assets/use/blacklist/1-6.jpg'),
  blacklistIndex7: require('@/assets/use/blacklist/1-7.jpg'),
  blacklistIndex8: require('@/assets/use/blacklist/1-8.jpg'),
  blacklistIndex9: require('@/assets/use/blacklist/1-9.jpg'),

  // 下载删除软件，主流程图片
  softwareIndex2: require('@/assets/use/software/1-2.jpg'),
  softwareIndex3: require('@/assets/use/software/1-3.jpg'),
  softwareIndex4: require('@/assets/use/software/1-4.jpg'),
  softwareIndex5: require('@/assets/use/software/1-5.jpg'),
  softwareIndex6: require('@/assets/use/software/1-6.jpg'),
  softwareIndex7: require('@/assets/use/software/1-7.jpg'),
  softwareIndex8: require('@/assets/use/software/1-8.jpg'),

  // 联系人，主流程图片
  contactsIndex2: require('@/assets/use/blacklist/1-2.jpg'),
  contactsIndex3: require('@/assets/use/contacts/1-3.jpg'),
  contactsIndex4: require('@/assets/use/contacts/1-4.jpg'),
  contactsIndex5: require('@/assets/use/contacts/1-5.jpg'),
  contactsIndex6: require('@/assets/use/contacts/1-6.jpg'),
  contactsIndex7: require('@/assets/use/contacts/1-7.jpg'),
  contactsIndex8: require('@/assets/use/contacts/1-8.jpg'),

  // 联系人，主流程图片
  flashlightIndex2: require('@/assets/use/flashlight/1-2.jpg'),
  flashlightIndex3: require('@/assets/use/flashlight/1-3.jpg'),
  flashlightIndex4: require('@/assets/use/flashlight/1-4.jpg'),

  // 添加和呼叫紧急联系人，主流程图片
  emergencyIndex2: require('@/assets/use/emergency/1-2.jpg'),
  emergencyIndex3: require('@/assets/use/emergency/1-3.jpg'),
  emergencyIndex4: require('@/assets/use/emergency/1-4.jpg'),
  emergencyIndex5: require('@/assets/use/emergency/1-5.jpg'),
  emergencyIndex6: require('@/assets/use/emergency/1-6.jpg'),
  emergencyIndex7: require('@/assets/use/emergency/1-7.jpg'),
  emergencyIndex8: require('@/assets/use/emergency/1-8.jpg'),
  emergencyIndex9: require('@/assets/use/emergency/1-9.jpg'),
  emergencyIndex10: require('@/assets/use/emergency/1-10.jpg'),
  emergencyIndex11: require('@/assets/use/emergency/1-11.jpg'),
  emergencyIndex12: require('@/assets/use/emergency/1-12.jpg'),

  // 连接wifi，主流程图片
  wifiIndex2: require('@/assets/phoneSettings/wifi/1-2.jpg'),
  wifiIndex3: require('@/assets/phoneSettings/wifi/1-3.jpg'),
  wifiIndex4: require('@/assets/phoneSettings/wifi/1-4.jpg'),
  wifiIndex5: require('@/assets/phoneSettings/wifi/1-5.jpg'),
  wifiIndex6: require('@/assets/phoneSettings/wifi/1-6.jpg'),

  // 查看和删除通知，主流程图片
  noticeIndex2: require('@/assets/phoneSettings/notice/1-2.jpg'),
  noticeIndex3: require('@/assets/phoneSettings/notice/1-3.jpg'),
  noticeIndex4: require('@/assets/phoneSettings/notice/1-4.jpg'),
  noticeIndex5: require('@/assets/phoneSettings/notice/1-5.jpg'),
  noticeIndex6: require('@/assets/phoneSettings/notice/1-6.jpg'),
  noticeIndex7: require('@/assets/phoneSettings/notice/1-7.jpg'),
  noticeIndex8: require('@/assets/phoneSettings/notice/1-8.jpg'),

  // 亮度和字号，主流程图片
  sizeIndex2: require('@/assets/phoneSettings/size/1-2.jpg'),
  sizeIndex3: require('@/assets/phoneSettings/size/1-3.jpg'),
  sizeIndex4: require('@/assets/phoneSettings/size/1-4.jpg'),
  sizeIndex5: require('@/assets/phoneSettings/size/1-5.jpg'),
  sizeIndex6: require('@/assets/phoneSettings/size/1-6.jpg'),
  sizeIndex7: require('@/assets/phoneSettings/size/1-7.jpg'),
  sizeIndex8: require('@/assets/phoneSettings/size/1-8.jpg'),
  sizeIndex9: require('@/assets/phoneSettings/size/1-9.jpg'),
  sizeIndex10: require('@/assets/phoneSettings/size/1-10.jpg'),

  branchSizeIndex2: require('@/assets/phoneSettings/size/2-2.jpg'),
  branchSizeIndex3: require('@/assets/phoneSettings/size/2-3.jpg'),
  branchSizeIndex4: require('@/assets/phoneSettings/size/2-4.jpg'),

  // 设置铃声，主流程图片
  ringToneIndex2: require('@/assets/phoneSettings/ringTone/1-2.jpg'),
  ringToneIndex3: require('@/assets/phoneSettings/ringTone/1-3.jpg'),
  ringToneIndex4: require('@/assets/phoneSettings/ringTone/1-4.jpg'),
  ringToneIndex5: require('@/assets/phoneSettings/ringTone/1-5.jpg'),
  ringToneIndex6: require('@/assets/phoneSettings/ringTone/1-6.jpg'),
  ringToneIndex7: require('@/assets/phoneSettings/ringTone/1-7.jpg'),
  ringToneIndex8: require('@/assets/phoneSettings/ringTone/1-8.jpg'),
  ringToneIndex9: require('@/assets/phoneSettings/ringTone/1-9.jpg'),

  branchRingToneIndex2: require('@/assets/phoneSettings/ringTone/2-2.jpg'),
  branchRingToneIndex3: require('@/assets/phoneSettings/ringTone/2-3.jpg'),
  branchRingToneIndex4: require('@/assets/phoneSettings/ringTone/2-4.jpg'),
  branchRingToneIndex5: require('@/assets/phoneSettings/ringTone/2-5.jpg'),

  // 清理空间，主流程图片
  spaceHuaWeiIndex2: require('@/assets/phoneSettings/space/huawei/1-2.jpg'),
  spaceHuaWeiIndex3: require('@/assets/phoneSettings/space/huawei/1-3.jpg'),
  spaceHuaWeiIndex4: require('@/assets/phoneSettings/space/huawei/1-4.jpg'),
  spaceHuaWeiIndex5: require('@/assets/phoneSettings/space/huawei/1-5.jpg'),
  spaceHuaWeiIndex6: require('@/assets/phoneSettings/space/huawei/1-6.jpg'),

  spaceMiIndex2: require('@/assets/phoneSettings/space/mi/1-2.jpg'),
  spaceMiIndex3: require('@/assets/phoneSettings/space/mi/1-3.jpg'),
  spaceMiIndex4: require('@/assets/phoneSettings/space/mi/1-4.jpg'),
  spaceMiIndex5: require('@/assets/phoneSettings/space/mi/1-5.jpg'),
  spaceMiIndex6: require('@/assets/phoneSettings/space/mi/1-6.jpg'),

  spaceVivoIndex2: require('@/assets/phoneSettings/space/vivo/1-2.jpg'),
  spaceVivoIndex3: require('@/assets/phoneSettings/space/vivo/1-3.jpg'),
  spaceVivoIndex4: require('@/assets/phoneSettings/space/vivo/1-4.jpg'),
  spaceVivoIndex5: require('@/assets/phoneSettings/space/vivo/1-5.jpg'),
  spaceVivoIndex6: require('@/assets/phoneSettings/space/vivo/1-6.jpg'),

  // 权限管理，主流程图片
  permissionHuaWeiIndex2: require('@/assets/phoneSettings/permission/huawei/1-2.jpg'),
  permissionHuaWeiIndex3: require('@/assets/phoneSettings/permission/huawei/1-3.jpg'),
  permissionHuaWeiIndex4: require('@/assets/phoneSettings/permission/huawei/1-4.jpg'),
  permissionHuaWeiIndex5: require('@/assets/phoneSettings/permission/huawei/1-5.jpg'),
  permissionHuaWeiIndex6: require('@/assets/phoneSettings/permission/huawei/1-6.jpg'),
  permissionHuaWeiIndex7: require('@/assets/phoneSettings/permission/huawei/1-7.jpg'),
  permissionHuaWeiIndex8: require('@/assets/phoneSettings/permission/huawei/1-8.jpg'),

  branchPermissionHuaWeiIndex1: require('@/assets/phoneSettings/permission/huawei/2-1.jpg'),
  branchPermissionHuaWeiIndex2: require('@/assets/phoneSettings/permission/huawei/2-2.jpg'),
  branchPermissionHuaWeiIndex3: require('@/assets/phoneSettings/permission/huawei/2-3.jpg'),
  branchPermissionHuaWeiIndex4: require('@/assets/phoneSettings/permission/huawei/2-4.jpg'),
  branchPermissionHuaWeiIndex5: require('@/assets/phoneSettings/permission/huawei/2-5.jpg'),

  permissionMiIndex2: require('@/assets/phoneSettings/permission/mi/1-2.jpg'),
  permissionMiIndex3: require('@/assets/phoneSettings/permission/mi/1-3.jpg'),
  permissionMiIndex4: require('@/assets/phoneSettings/permission/mi/1-4.jpg'),
  permissionMiIndex5: require('@/assets/phoneSettings/permission/mi/1-5.jpg'),
  permissionMiIndex6: require('@/assets/phoneSettings/permission/mi/1-6.jpg'),
  permissionMiIndex7: require('@/assets/phoneSettings/permission/mi/1-7.jpg'),

  branchPermissionMiIndex1: require('@/assets/phoneSettings/permission/mi/2-1.jpg'),
  branchPermissionMiIndex2: require('@/assets/phoneSettings/permission/mi/2-2.jpg'),
  branchPermissionMiIndex3: require('@/assets/phoneSettings/permission/mi/2-3.jpg'),
  branchPermissionMiIndex4: require('@/assets/phoneSettings/permission/mi/2-4.jpg'),
  branchPermissionMiIndex5: require('@/assets/phoneSettings/permission/mi/2-5.jpg'),
  branchPermissionMiIndex6: require('@/assets/phoneSettings/permission/mi/2-6.jpg'),

  permissionVivoIndex2: require('@/assets/phoneSettings/permission/vivo/1-2.jpg'),
  permissionVivoIndex3: require('@/assets/phoneSettings/permission/vivo/1-3.jpg'),
  permissionVivoIndex4: require('@/assets/phoneSettings/permission/vivo/1-4.jpg'),
  permissionVivoIndex5: require('@/assets/phoneSettings/permission/vivo/1-5.jpg'),
  permissionVivoIndex6: require('@/assets/phoneSettings/permission/vivo/1-6.jpg'),
  permissionVivoIndex7: require('@/assets/phoneSettings/permission/vivo/1-7.jpg'),
  permissionVivoIndex8: require('@/assets/phoneSettings/permission/vivo/1-8.jpg'),
  permissionVivoIndex9: require('@/assets/phoneSettings/permission/vivo/1-9.jpg'),

  branchPermissionVivoIndex1: require('@/assets/phoneSettings/permission/vivo/2-1.jpg'),
  branchPermissionVivoIndex2: require('@/assets/phoneSettings/permission/vivo/2-2.jpg'),
  branchPermissionVivoIndex3: require('@/assets/phoneSettings/permission/vivo/2-3.jpg'),
  branchPermissionVivoIndex4: require('@/assets/phoneSettings/permission/vivo/2-4.jpg'),
  branchPermissionVivoIndex5: require('@/assets/phoneSettings/permission/vivo/2-5.jpg'),
  branchPermissionVivoIndex6: require('@/assets/phoneSettings/permission/vivo/2-6.jpg'),
  branchPermissionVivoIndex7: require('@/assets/phoneSettings/permission/vivo/2-7.jpg'),

  // 设置开机密码，主流程图片
  passwordIndex2: require('@/assets/phoneSettings/password/1-2.jpg'),
  passwordIndex3: require('@/assets/phoneSettings/password/1-3.jpg'),
  passwordIndex4: require('@/assets/phoneSettings/password/1-4.jpg'),
  passwordIndex5: require('@/assets/phoneSettings/password/1-5.jpg'),
  passwordIndex6: require('@/assets/phoneSettings/password/1-6.jpg'),
  passwordIndex7: require('@/assets/phoneSettings/password/1-7.jpg'),
  branchPasswordIndex1: require('@/assets/phoneSettings/password/2-1.jpg'),
  branchPasswordIndex2: require('@/assets/phoneSettings/password/2-2.jpg'),
  branchPasswordIndex3: require('@/assets/phoneSettings/password/2-3.jpg'),
  branchPasswordIndex4: require('@/assets/phoneSettings/password/2-4.jpg'),
  branchPasswordIndex5: require('@/assets/phoneSettings/password/2-5.jpg'),

  // 添加和删除微信好友，主流程图片
  friendIndex2: require('@/assets/wxSettings/friend/1-2.jpg'),
  friendIndex3: require('@/assets/wxSettings/friend/1-3.jpg'),
  friendIndex4: require('@/assets/wxSettings/friend/1-4.jpg'),
  friendIndex5: require('@/assets/wxSettings/friend/1-5.jpg'),
  friendIndex6: require('@/assets/wxSettings/friend/1-6.jpg'),
  friendIndex7: require('@/assets/wxSettings/friend/1-7.jpg'),
  friendIndex8: require('@/assets/wxSettings/friend/1-8.jpg'),
  friendIndex9: require('@/assets/wxSettings/friend/1-9.jpg'),
  friendIndex10: require('@/assets/wxSettings/friend/1-10.jpg'),
  friendIndex11: require('@/assets/wxSettings/friend/1-11.jpg'),
  friendIndex12: require('@/assets/wxSettings/friend/1-12.jpg'),
  friendIndex13: require('@/assets/wxSettings/friend/1-13.jpg'),

  branchFriendIndex1: require('@/assets/wxSettings/friend/2-1.jpg'),
  branchFriendIndex2: require('@/assets/wxSettings/friend/2-2.jpg'),
  branchFriendIndex3: require('@/assets/wxSettings/friend/2-3.jpg'),
  branchFriendIndex4: require('@/assets/wxSettings/friend/2-4.jpg'),
  branchFriendIndex5: require('@/assets/wxSettings/friend/2-5.jpg'),
  branchFriendIndex6: require('@/assets/wxSettings/friend/2-6.jpg'),

  // 语音视频聊天，主流程图片
  chatIndex1: require('@/assets/wxSettings/chat/1-1.jpg'),
  chatIndex2: require('@/assets/wxSettings/chat/1-2.jpg'),
  chatIndex3: require('@/assets/wxSettings/chat/1-3.jpg'),
  chatIndex4: require('@/assets/wxSettings/chat/1-4.jpg'),
  chatIndex5: require('@/assets/wxSettings/chat/1-5.jpg'),
  chatIndex6: require('@/assets/wxSettings/chat/1-6.jpg'),
  chatIndex7: require('@/assets/wxSettings/chat/1-7.jpg'),
  chatIndex8: require('@/assets/wxSettings/chat/1-8.jpg'),
  chatIndex9: require('@/assets/wxSettings/chat/1-9.jpg'),
  chatIndex10: require('@/assets/wxSettings/chat/1-10.jpg'),
  chatIndex11: require('@/assets/wxSettings/chat/1-11.jpg'),

  branchChatIndex1: require('@/assets/wxSettings/chat/2-1.jpg'),
  branchChatIndex2: require('@/assets/wxSettings/chat/2-2.jpg'),
  branchChatIndex4: require('@/assets/wxSettings/chat/2-4.jpg'),
  branchChatIndex5: require('@/assets/wxSettings/chat/2-5.jpg'),
  branchChatIndex6: require('@/assets/wxSettings/chat/2-6.jpg'),

  // 关怀模式，主流程图片
  careIndex2: require('@/assets/wxSettings/care/1-2.jpg'),
  careIndex3: require('@/assets/wxSettings/care/1-3.jpg'),
  careIndex4: require('@/assets/wxSettings/care/1-4.jpg'),
  careIndex5: require('@/assets/wxSettings/care/1-5.jpg'),
  careIndex6: require('@/assets/wxSettings/care/1-6.jpg'),
  careIndex7: require('@/assets/wxSettings/care/1-7.jpg'),

  // 群聊，主流程图片
  groupChatIndex2: require('@/assets/wxSettings/groupChat/1-2.jpg'),
  groupChatIndex3: require('@/assets/wxSettings/groupChat/1-3.jpg'),
  groupChatIndex4: require('@/assets/wxSettings/groupChat/1-4.jpg'),
  groupChatIndex5: require('@/assets/wxSettings/groupChat/1-5.jpg'),
  groupChatIndex6: require('@/assets/wxSettings/groupChat/1-6.jpg'),
  groupChatIndex7: require('@/assets/wxSettings/groupChat/1-7.jpg'),
  groupChatIndex8: require('@/assets/wxSettings/groupChat/1-8.jpg'),
  groupChatIndex9: require('@/assets/wxSettings/groupChat/1-9.jpg'),
  groupChatIndex10: require('@/assets/wxSettings/groupChat/1-10.jpg'),

  branch1groupChatIndex1: require('@/assets/wxSettings/groupChat/2-1.jpg'),
  branch1groupChatIndex2: require('@/assets/wxSettings/groupChat/2-2.jpg'),
  branch1groupChatIndex3: require('@/assets/wxSettings/groupChat/2-3.jpg'),
  branch1groupChatIndex4: require('@/assets/wxSettings/groupChat/2-4.jpg'),
  branch1groupChatIndex5: require('@/assets/wxSettings/groupChat/2-5.jpg'),
  branch2groupChatIndex1: require('@/assets/wxSettings/groupChat/3-1.jpg'),
  branch2groupChatIndex2: require('@/assets/wxSettings/groupChat/3-2.jpg'),
  branch2groupChatIndex3: require('@/assets/wxSettings/groupChat/3-3.jpg'),
  branch2groupChatIndex4: require('@/assets/wxSettings/groupChat/3-4.jpg'),

  // 微信清理空间，主流程图片
  spaceIndex2: require('@/assets/wxSettings/space/1-2.jpg'),
  spaceIndex3: require('@/assets/wxSettings/space/1-3.jpg'),
  spaceIndex4: require('@/assets/wxSettings/space/1-4.jpg'),
  spaceIndex5: require('@/assets/wxSettings/space/1-5.jpg'),
  spaceIndex6: require('@/assets/wxSettings/space/1-6.jpg'),
  spaceIndex7: require('@/assets/wxSettings/space/1-7.jpg'),
  spaceIndex8: require('@/assets/wxSettings/space/1-8.jpg'),
  spaceIndex9: require('@/assets/wxSettings/space/1-9.jpg'),
  spaceIndex10: require('@/assets/wxSettings/space/1-10.jpg'),
  spaceIndex11: require('@/assets/wxSettings/space/1-11.jpg'),
  spaceIndex12: require('@/assets/wxSettings/space/1-12.jpg'),
  spaceIndex13: require('@/assets/wxSettings/space/1-13.jpg'),
  spaceIndex14: require('@/assets/wxSettings/space/1-14.jpg'),
  spaceIndex15: require('@/assets/wxSettings/space/1-15.jpg'),
  spaceIndex16: require('@/assets/wxSettings/space/1-16.jpg'),

  // 微信表情包发语音，主流程图片
  expressionIndex3: require('@/assets/wxSettings/expression/1-3.jpg'),
  expressionIndex4: require('@/assets/wxSettings/expression/1-4.jpg'),
  expressionIndex5: require('@/assets/wxSettings/expression/1-5.jpg'),
  expressionIndex6: require('@/assets/wxSettings/expression/1-6.jpg'),
  expressionIndex7: require('@/assets/wxSettings/expression/1-7.jpg'),
  expressionIndex8: require('@/assets/wxSettings/expression/1-8.jpg'),

  branch1expressionIndex1: require('@/assets/wxSettings/expression/2-1.jpg'),
  branch1expressionIndex2: require('@/assets/wxSettings/expression/2-2.jpg'),
  branch1expressionIndex3: require('@/assets/wxSettings/expression/2-3.jpg'),

  branch2expressionIndex1: require('@/assets/wxSettings/expression/3-1.jpg'),
  branch2expressionIndex2: require('@/assets/wxSettings/expression/3-2.jpg'),
  branch2expressionIndex3: require('@/assets/wxSettings/expression/3-3.jpg'),
  branch2expressionIndex4: require('@/assets/wxSettings/expression/3-4.jpg'),
  branch2expressionIndex5: require('@/assets/wxSettings/expression/3-5.jpg'),
  branch2expressionIndex6: require('@/assets/wxSettings/expression/3-6.jpg'),
  branch2expressionIndex7: require('@/assets/wxSettings/expression/3-7.jpg'),

  branch3expressionIndex1: require('@/assets/wxSettings/expression/4-1.jpg'),
  branch3expressionIndex2: require('@/assets/wxSettings/expression/4-2.jpg'),
  branch3expressionIndex3: require('@/assets/wxSettings/expression/4-3.jpg'),
  branch3expressionIndex4: require('@/assets/wxSettings/expression/4-4.jpg'),
  branch3expressionIndex5: require('@/assets/wxSettings/expression/4-5.jpg'),
  branch3expressionIndex6: require('@/assets/wxSettings/expression/4-6.jpg'),

  // 切换输入法
  inputIndex1: require('@/assets/wxSettings/input/1-1.jpg'),
  inputIndex2: require('@/assets/wxSettings/input/1-2.jpg'),
  inputIndex3: require('@/assets/wxSettings/input/1-3.jpg'),
  inputIndex4: require('@/assets/wxSettings/input/1-4.jpg'),

  // 反诈APP，主流程图片
  antiFraudAPPIndex2: require('@/assets/shopping/antiFraudAPP/1-2.jpg'),
  antiFraudAPPIndex3: require('@/assets/shopping/antiFraudAPP/1-3.jpg'),
  antiFraudAPPIndex4: require('@/assets/shopping/antiFraudAPP/1-4.jpg'),
  antiFraudAPPIndex5: require('@/assets/shopping/antiFraudAPP/1-5.jpg'),
  antiFraudAPPIndex6: require('@/assets/shopping/antiFraudAPP/1-6.jpg'),
  antiFraudAPPIndex7: require('@/assets/shopping/antiFraudAPP/1-7.jpg'),
  antiFraudAPPIndex8: require('@/assets/shopping/antiFraudAPP/1-8.jpg'),
  antiFraudAPPIndex9: require('@/assets/shopping/antiFraudAPP/1-9.jpg'),
  antiFraudAPPIndex10: require('@/assets/shopping/antiFraudAPP/1-10.jpg'),
  antiFraudAPPIndex11: require('@/assets/shopping/antiFraudAPP/1-11.jpg'),
  antiFraudAPPIndex12: require('@/assets/shopping/antiFraudAPP/1-12.jpg'),

  // 银行余额和明细
  detailsHSBankIndex2: require('@/assets/shopping/details/HSBank/1-2.jpg'),
  detailsHSBankIndex3: require('@/assets/shopping/details/HSBank/1-3.jpg'),
  detailsHSBankIndex4: require('@/assets/shopping/details/HSBank/1-4.jpg'),
  detailsHSBankIndex5: require('@/assets/shopping/details/HSBank/1-5.jpg'),
  detailsHSBankIndex6: require('@/assets/shopping/details/HSBank/1-6.jpg'),
  detailsHSBankIndex7: require('@/assets/shopping/details/HSBank/1-7.jpg'),
  detailsICBankIndex2: require('@/assets/shopping/details/ICBank/1-2.jpg'),
  detailsICBankIndex3: require('@/assets/shopping/details/ICBank/1-3.jpg'),
  detailsICBankIndex4: require('@/assets/shopping/details/ICBank/1-4.jpg'),
  detailsICBankIndex5: require('@/assets/shopping/details/ICBank/1-5.jpg'),
  detailsICBankIndex6: require('@/assets/shopping/details/ICBank/1-6.jpg'),
  detailsICBankIndex7: require('@/assets/shopping/details/ICBank/1-7.jpg'),

  // 银行转账
  bankTransferHSBankIndex2: require('@/assets/shopping/bankTransfer/HSBank/1-2.jpg'),
  bankTransferHSBankIndex3: require('@/assets/shopping/bankTransfer/HSBank/1-3.jpg'),
  bankTransferHSBankIndex4: require('@/assets/shopping/bankTransfer/HSBank/1-4.jpg'),
  bankTransferHSBankIndex5: require('@/assets/shopping/bankTransfer/HSBank/1-5.jpg'),
  bankTransferHSBankIndex6: require('@/assets/shopping/bankTransfer/HSBank/1-6.jpg'),
  bankTransferHSBankIndex7: require('@/assets/shopping/bankTransfer/HSBank/1-7.jpg'),
  bankTransferHSBankIndex8: require('@/assets/shopping/bankTransfer/HSBank/1-8.jpg'),
  bankTransferICBankIndex2: require('@/assets/shopping/bankTransfer/ICBank/1-2.jpg'),
  bankTransferICBankIndex3: require('@/assets/shopping/bankTransfer/ICBank/1-3.jpg'),
  bankTransferICBankIndex4: require('@/assets/shopping/bankTransfer/ICBank/1-4.jpg'),
  bankTransferICBankIndex5: require('@/assets/shopping/bankTransfer/ICBank/1-5.jpg'),
  bankTransferICBankIndex6: require('@/assets/shopping/bankTransfer/ICBank/1-6.jpg'),
  bankTransferICBankIndex7: require('@/assets/shopping/bankTransfer/ICBank/1-7.jpg'),
  bankTransferICBankIndex8: require('@/assets/shopping/bankTransfer/ICBank/1-8.jpg'),

  // 绑定银行卡
  bankCardzfbIndex2: require('@/assets/shopping/bankCard/zfb/1-2.jpg'),
  bankCardzfbIndex3: require('@/assets/shopping/bankCard/zfb/1-3.jpg'),
  bankCardzfbIndex4: require('@/assets/shopping/bankCard/zfb/1-4.jpg'),
  bankCardzfbIndex5: require('@/assets/shopping/bankCard/zfb/1-5.jpg'),
  bankCardzfbIndex6: require('@/assets/shopping/bankCard/zfb/1-6.jpg'),
  bankCardzfbIndex7: require('@/assets/shopping/bankCard/zfb/1-7.jpg'),
  bankCardzfbIndex8: require('@/assets/shopping/bankCard/zfb/1-8.jpg'),

  bankCardwxIndex2: require('@/assets/shopping/bankCard/wx/1-2.jpg'),
  bankCardwxIndex3: require('@/assets/shopping/bankCard/wx/1-3.jpg'),
  bankCardwxIndex4: require('@/assets/shopping/bankCard/wx/1-4.jpg'),
  bankCardwxIndex5: require('@/assets/shopping/bankCard/wx/1-5.jpg'),
  bankCardwxIndex6: require('@/assets/shopping/bankCard/wx/1-6.jpg'),
  bankCardwxIndex7: require('@/assets/shopping/bankCard/wx/1-7.jpg'),
  bankCardwxIndex8: require('@/assets/shopping/bankCard/wx/1-8.jpg'),
  bankCardwxIndex9: require('@/assets/shopping/bankCard/wx/1-9.jpg'),
  bankCardwxIndex10: require('@/assets/shopping/bankCard/wx/1-10.jpg'),
  bankCardwxIndex11: require('@/assets/shopping/bankCard/wx/1-11.jpg'),
  bankCardwxIndex12: require('@/assets/shopping/bankCard/wx/1-12.jpg'),
  bankCardwxIndex13: require('@/assets/shopping/bankCard/wx/1-13.jpg'),

  // 提现
  withdrawalzfbIndex3: require('@/assets/shopping/withdrawal/zfb/1-3.jpg'),
  withdrawalzfbIndex4: require('@/assets/shopping/withdrawal/zfb/1-4.jpg'),
  withdrawalzfbIndex5: require('@/assets/shopping/withdrawal/zfb/1-5.jpg'),
  withdrawalzfbIndex6: require('@/assets/shopping/withdrawal/zfb/1-6.jpg'),
  withdrawalzfbIndex7: require('@/assets/shopping/withdrawal/zfb/1-7.jpg'),
  withdrawalzfbIndex8: require('@/assets/shopping/withdrawal/zfb/1-8.jpg'),
  withdrawalzfbIndex9: require('@/assets/shopping/withdrawal/zfb/1-9.jpg'),
  withdrawalzfbIndex10: require('@/assets/shopping/withdrawal/zfb/1-10.jpg'),

  withdrawalwxIndex5: require('@/assets/shopping/withdrawal/wx/1-5.jpg'),
  withdrawalwxIndex6: require('@/assets/shopping/withdrawal/wx/1-6.jpg'),
  withdrawalwxIndex7: require('@/assets/shopping/withdrawal/wx/1-7.jpg'),
  withdrawalwxIndex8: require('@/assets/shopping/withdrawal/wx/1-8.jpg'),
  withdrawalwxIndex9: require('@/assets/shopping/withdrawal/wx/1-9.jpg'),
  withdrawalwxIndex10: require('@/assets/shopping/withdrawal/wx/1-10.jpg'),
  withdrawalwxIndex11: require('@/assets/shopping/withdrawal/wx/1-11.jpg'),

  // 微信支付宝转账
  transferAccountszfbIndex2: require('@/assets/shopping/transferAccounts/zfb/1-2.jpg'),
  transferAccountszfbIndex3: require('@/assets/shopping/transferAccounts/zfb/1-3.jpg'),
  transferAccountszfbIndex4: require('@/assets/shopping/transferAccounts/zfb/1-4.jpg'),
  transferAccountszfbIndex5: require('@/assets/shopping/transferAccounts/zfb/1-5.jpg'),
  transferAccountszfbIndex6: require('@/assets/shopping/transferAccounts/zfb/1-6.jpg'),
  transferAccountszfbIndex7: require('@/assets/shopping/transferAccounts/zfb/1-7.jpg'),
  transferAccountszfbIndex8: require('@/assets/shopping/transferAccounts/zfb/1-8.jpg'),
  transferAccountszfbIndex9: require('@/assets/shopping/transferAccounts/zfb/1-9.jpg'),

  branchtransferAccountszfbIndex1: require('@/assets/shopping/transferAccounts/zfb/2-1.jpg'),
  branchtransferAccountszfbIndex2: require('@/assets/shopping/transferAccounts/zfb/2-2.jpg'),
  branchtransferAccountszfbIndex3: require('@/assets/shopping/transferAccounts/zfb/2-3.jpg'),
  branchtransferAccountszfbIndex4: require('@/assets/shopping/transferAccounts/zfb/2-4.jpg'),
  branchtransferAccountszfbIndex5: require('@/assets/shopping/transferAccounts/zfb/2-5.jpg'),
  branchtransferAccountszfbIndex6: require('@/assets/shopping/transferAccounts/zfb/2-6.jpg'),
  branchtransferAccountszfbIndex7: require('@/assets/shopping/transferAccounts/zfb/2-7.jpg'),

  transferAccountswxIndex2: require('@/assets/shopping/transferAccounts/wx/1-2.jpg'),
  transferAccountswxIndex3: require('@/assets/shopping/transferAccounts/wx/1-3.jpg'),
  transferAccountswxIndex4: require('@/assets/shopping/transferAccounts/wx/1-4.jpg'),
  transferAccountswxIndex5: require('@/assets/shopping/transferAccounts/wx/1-5.jpg'),
  transferAccountswxIndex6: require('@/assets/shopping/transferAccounts/wx/1-6.jpg'),
  transferAccountswxIndex7: require('@/assets/shopping/transferAccounts/wx/1-7.jpg'),
  transferAccountswxIndex8: require('@/assets/shopping/transferAccounts/wx/1-8.jpg'),
  transferAccountswxIndex9: require('@/assets/shopping/transferAccounts/wx/1-9.jpg'),

  branch1transferAccountswxIndex1: require('@/assets/shopping/transferAccounts/wx/2-1.jpg'),
  branch1transferAccountswxIndex2: require('@/assets/shopping/transferAccounts/wx/2-2.jpg'),
  branch1transferAccountswxIndex3: require('@/assets/shopping/transferAccounts/wx/2-3.jpg'),
  branch1transferAccountswxIndex4: require('@/assets/shopping/transferAccounts/wx/2-4.jpg'),
  branch1transferAccountswxIndex5: require('@/assets/shopping/transferAccounts/wx/2-5.jpg'),
  branch1transferAccountswxIndex6: require('@/assets/shopping/transferAccounts/wx/2-6.jpg'),
  branch1transferAccountswxIndex7: require('@/assets/shopping/transferAccounts/wx/2-7.jpg'),

  branch2transferAccountswxIndex1: require('@/assets/shopping/transferAccounts/wx/3-1.jpg'),
  branch2transferAccountswxIndex2: require('@/assets/shopping/transferAccounts/wx/3-2.jpg'),
  branch2transferAccountswxIndex3: require('@/assets/shopping/transferAccounts/wx/3-3.jpg'),
  branch2transferAccountswxIndex4: require('@/assets/shopping/transferAccounts/wx/3-4.jpg'),
  branch2transferAccountswxIndex5: require('@/assets/shopping/transferAccounts/wx/3-5.jpg'),
  branch2transferAccountswxIndex6: require('@/assets/shopping/transferAccounts/wx/3-6.jpg'),
  branch2transferAccountswxIndex7: require('@/assets/shopping/transferAccounts/wx/3-7.jpg'),
  branch2transferAccountswxIndex8: require('@/assets/shopping/transferAccounts/wx/3-8.jpg'),

  branch3transferAccountswxIndex1: require('@/assets/shopping/transferAccounts/wx/4-1.jpg'),
  branch3transferAccountswxIndex2: require('@/assets/shopping/transferAccounts/wx/4-2.jpg'),
  branch3transferAccountswxIndex3: require('@/assets/shopping/transferAccounts/wx/4-3.jpg'),
  branch3transferAccountswxIndex4: require('@/assets/shopping/transferAccounts/wx/4-4.jpg'),
  branch3transferAccountswxIndex5: require('@/assets/shopping/transferAccounts/wx/4-5.jpg'),
  branch3transferAccountswxIndex6: require('@/assets/shopping/transferAccounts/wx/4-6.jpg'),
  branch3transferAccountswxIndex7: require('@/assets/shopping/transferAccounts/wx/4-7.jpg'),
  branch3transferAccountswxIndex8: require('@/assets/shopping/transferAccounts/wx/4-8.jpg'),

  // 扫码支付
  paymentzfbIndex2: require('@/assets/shopping/payment/zfb/1-2.jpg'),
  paymentzfbIndex3: require('@/assets/shopping/payment/zfb/1-3.jpg'),
  paymentzfbIndex4: require('@/assets/shopping/payment/zfb/1-4.jpg'),
  paymentzfbIndex5: require('@/assets/shopping/payment/zfb/1-5.jpg'),
  paymentzfbIndex6: require('@/assets/shopping/payment/zfb/1-6.jpg'),
  paymentzfbIndex7: require('@/assets/shopping/payment/zfb/1-7.jpg'),

  branch1paymentzfbIndex1: require('@/assets/shopping/payment/zfb/2-1.jpg'),
  branch1paymentzfbIndex2: require('@/assets/shopping/payment/zfb/2-2.jpg'),

  branch2paymentzfbIndex1: require('@/assets/shopping/payment/zfb/3-1.jpg'),
  branch2paymentzfbIndex2: require('@/assets/shopping/payment/zfb/3-2.jpg'),
  branch2paymentzfbIndex3: require('@/assets/shopping/payment/zfb/3-3.jpg'),

  paymentwxIndex2: require('@/assets/shopping/payment/wx/1-2.jpg'),
  paymentwxIndex3: require('@/assets/shopping/payment/wx/1-3.jpg'),
  paymentwxIndex4: require('@/assets/shopping/payment/wx/1-4.jpg'),
  paymentwxIndex5: require('@/assets/shopping/payment/wx/1-5.jpg'),
  paymentwxIndex6: require('@/assets/shopping/payment/wx/1-6.jpg'),
  paymentwxIndex7: require('@/assets/shopping/payment/wx/1-7.jpg'),

  branch1paymentwxIndex1: require('@/assets/shopping/payment/wx/2-1.jpg'),
  branch1paymentwxIndex2: require('@/assets/shopping/payment/wx/2-2.jpg'),
  branch1paymentwxIndex3: require('@/assets/shopping/payment/wx/2-3.jpg'),

  branch2paymentwxIndex1: require('@/assets/shopping/payment/wx/3-1.jpg'),
  branch2paymentwxIndex2: require('@/assets/shopping/payment/wx/3-2.jpg'),
  branch2paymentwxIndex3: require('@/assets/shopping/payment/wx/3-3.jpg'),
  branch2paymentwxIndex4: require('@/assets/shopping/payment/wx/3-4.jpg'),

  // 手机网购
  onlineShoppingdyIndex2: require('@/assets/shopping/onlineShopping/dy/1-2.jpg'),
  onlineShoppingdyIndex3: require('@/assets/shopping/onlineShopping/dy/1-3.jpg'),
  onlineShoppingdyIndex4: require('@/assets/shopping/onlineShopping/dy/1-4.jpg'),
  onlineShoppingdyIndex5: require('@/assets/shopping/onlineShopping/dy/1-5.jpg'),
  onlineShoppingdyIndex6: require('@/assets/shopping/onlineShopping/dy/1-6.jpg'),
  onlineShoppingdyIndex7: require('@/assets/shopping/onlineShopping/dy/1-7.jpg'),
  onlineShoppingdyIndex8: require('@/assets/shopping/onlineShopping/dy/1-8.jpg'),
  onlineShoppingdyIndex9: require('@/assets/shopping/onlineShopping/dy/1-9.jpg'),
  onlineShoppingdyIndex10: require('@/assets/shopping/onlineShopping/dy/1-10.jpg'),
  onlineShoppingdyIndex11: require('@/assets/shopping/onlineShopping/dy/1-11.jpg'),
  onlineShoppingdyIndex12: require('@/assets/shopping/onlineShopping/dy/1-12.jpg'),

  branch1onlineShoppingdyIndex1: require('@/assets/shopping/onlineShopping/dy/2-1.jpg'),
  branch1onlineShoppingdyIndex2: require('@/assets/shopping/onlineShopping/dy/2-2.jpg'),
  branch1onlineShoppingdyIndex3: require('@/assets/shopping/onlineShopping/dy/2-3.jpg'),
  branch1onlineShoppingdyIndex4: require('@/assets/shopping/onlineShopping/dy/2-4.jpg'),
  branch1onlineShoppingdyIndex5: require('@/assets/shopping/onlineShopping/dy/2-5.jpg'),
  branch1onlineShoppingdyIndex6: require('@/assets/shopping/onlineShopping/dy/2-6.jpg'),
  branch1onlineShoppingdyIndex7: require('@/assets/shopping/onlineShopping/dy/2-7.jpg'),

  branch2onlineShoppingdyIndex1: require('@/assets/shopping/onlineShopping/dy/3-1.jpg'),
  branch2onlineShoppingdyIndex2: require('@/assets/shopping/onlineShopping/dy/3-2.jpg'),
  branch2onlineShoppingdyIndex3: require('@/assets/shopping/onlineShopping/dy/3-3.jpg'),
  branch2onlineShoppingdyIndex4: require('@/assets/shopping/onlineShopping/dy/3-4.jpg'),
  branch2onlineShoppingdyIndex5: require('@/assets/shopping/onlineShopping/dy/3-5.jpg'),
  branch2onlineShoppingdyIndex6: require('@/assets/shopping/onlineShopping/dy/3-6.jpg'),
  // branch2onlineShoppingdyIndex7: require("@/assets/shopping/onlineShopping/dy/3-7.jpg"),

  branch3onlineShoppingdyIndex1: require('@/assets/shopping/onlineShopping/dy/4-1.jpg'),
  branch3onlineShoppingdyIndex2: require('@/assets/shopping/onlineShopping/dy/4-2.jpg'),
  branch3onlineShoppingdyIndex3: require('@/assets/shopping/onlineShopping/dy/4-3.jpg'),

  onlineShoppingjdIndex2: require('@/assets/shopping/onlineShopping/jd/1-2.jpg'),
  onlineShoppingjdIndex3: require('@/assets/shopping/onlineShopping/jd/1-3.jpg'),
  onlineShoppingjdIndex4: require('@/assets/shopping/onlineShopping/jd/1-4.jpg'),
  onlineShoppingjdIndex5: require('@/assets/shopping/onlineShopping/jd/1-5.jpg'),
  onlineShoppingjdIndex6: require('@/assets/shopping/onlineShopping/jd/1-6.jpg'),
  onlineShoppingjdIndex7: require('@/assets/shopping/onlineShopping/jd/1-7.jpg'),
  onlineShoppingjdIndex8: require('@/assets/shopping/onlineShopping/jd/1-8.jpg'),
  onlineShoppingjdIndex9: require('@/assets/shopping/onlineShopping/jd/1-9.jpg'),
  onlineShoppingjdIndex10: require('@/assets/shopping/onlineShopping/jd/1-10.jpg'),
  onlineShoppingjdIndex11: require('@/assets/shopping/onlineShopping/jd/1-11.jpg'),
  onlineShoppingjdIndex12: require('@/assets/shopping/onlineShopping/jd/1-12.jpg'),
  onlineShoppingjdIndex13: require('@/assets/shopping/onlineShopping/jd/1-13.jpg'),
  onlineShoppingjdIndex14: require('@/assets/shopping/onlineShopping/jd/1-14.jpg'),

  branch1onlineShoppingjdIndex1: require('@/assets/shopping/onlineShopping/jd/2-1.jpg'),
  branch1onlineShoppingjdIndex2: require('@/assets/shopping/onlineShopping/jd/2-2.jpg'),
  branch1onlineShoppingjdIndex3: require('@/assets/shopping/onlineShopping/jd/2-3.jpg'),
  branch1onlineShoppingjdIndex4: require('@/assets/shopping/onlineShopping/jd/2-4.jpg'),
  branch1onlineShoppingjdIndex5: require('@/assets/shopping/onlineShopping/jd/2-5.jpg'),
  branch1onlineShoppingjdIndex6: require('@/assets/shopping/onlineShopping/jd/2-6.jpg'),

  branch2onlineShoppingjdIndex1: require('@/assets/shopping/onlineShopping/jd/3-1.jpg'),
  branch2onlineShoppingjdIndex2: require('@/assets/shopping/onlineShopping/jd/3-2.jpg'),
  branch2onlineShoppingjdIndex3: require('@/assets/shopping/onlineShopping/jd/3-3.jpg'),
  branch2onlineShoppingjdIndex4: require('@/assets/shopping/onlineShopping/jd/3-4.jpg'),
  branch2onlineShoppingjdIndex5: require('@/assets/shopping/onlineShopping/jd/3-5.jpg'),
  branch2onlineShoppingjdIndex6: require('@/assets/shopping/onlineShopping/jd/3-6.jpg'),
  // branch2onlineShoppingjdIndex7: require("@/assets/shopping/onlineShopping/jd/3-7.jpg"),

  branch3onlineShoppingjdIndex1: require('@/assets/shopping/onlineShopping/jd/4-1.jpg'),
  branch3onlineShoppingjdIndex2: require('@/assets/shopping/onlineShopping/jd/4-2.jpg'),
  branch3onlineShoppingjdIndex3: require('@/assets/shopping/onlineShopping/jd/4-3.jpg'),
  branch3onlineShoppingjdIndex4: require('@/assets/shopping/onlineShopping/jd/4-4.jpg'),
  branch3onlineShoppingjdIndex5: require('@/assets/shopping/onlineShopping/jd/4-5.jpg'),

  onlineShoppingpddIndex2: require('@/assets/shopping/onlineShopping/pdd/1-2.jpg'),
  onlineShoppingpddIndex3: require('@/assets/shopping/onlineShopping/pdd/1-3.jpg'),
  onlineShoppingpddIndex4: require('@/assets/shopping/onlineShopping/pdd/1-4.jpg'),
  onlineShoppingpddIndex5: require('@/assets/shopping/onlineShopping/pdd/1-5.jpg'),
  onlineShoppingpddIndex6: require('@/assets/shopping/onlineShopping/pdd/1-6.jpg'),
  onlineShoppingpddIndex7: require('@/assets/shopping/onlineShopping/pdd/1-7.jpg'),
  onlineShoppingpddIndex8: require('@/assets/shopping/onlineShopping/pdd/1-8.jpg'),
  onlineShoppingpddIndex9: require('@/assets/shopping/onlineShopping/pdd/1-9.jpg'),
  onlineShoppingpddIndex10: require('@/assets/shopping/onlineShopping/pdd/1-10.jpg'),

  branch1onlineShoppingpddIndex1: require('@/assets/shopping/onlineShopping/pdd/2-1.jpg'),
  branch1onlineShoppingpddIndex2: require('@/assets/shopping/onlineShopping/pdd/2-2.jpg'),
  branch1onlineShoppingpddIndex3: require('@/assets/shopping/onlineShopping/pdd/2-3.jpg'),
  branch1onlineShoppingpddIndex4: require('@/assets/shopping/onlineShopping/pdd/2-4.jpg'),
  branch1onlineShoppingpddIndex5: require('@/assets/shopping/onlineShopping/pdd/2-5.jpg'),
  branch1onlineShoppingpddIndex6: require('@/assets/shopping/onlineShopping/pdd/2-6.jpg'),

  branch2onlineShoppingpddIndex1: require('@/assets/shopping/onlineShopping/pdd/3-1.jpg'),
  branch2onlineShoppingpddIndex2: require('@/assets/shopping/onlineShopping/pdd/3-2.jpg'),
  branch2onlineShoppingpddIndex3: require('@/assets/shopping/onlineShopping/pdd/3-3.jpg'),
  branch2onlineShoppingpddIndex4: require('@/assets/shopping/onlineShopping/pdd/3-4.jpg'),
  branch2onlineShoppingpddIndex5: require('@/assets/shopping/onlineShopping/pdd/3-5.jpg'),
  branch2onlineShoppingpddIndex6: require('@/assets/shopping/onlineShopping/pdd/3-6.jpg'),
  branch2onlineShoppingpddIndex7: require('@/assets/shopping/onlineShopping/pdd/3-7.jpg'),
  branch2onlineShoppingpddIndex8: require('@/assets/shopping/onlineShopping/pdd/3-8.jpg'),

  branch3onlineShoppingpddIndex1: require('@/assets/shopping/onlineShopping/pdd/4-1.jpg'),
  branch3onlineShoppingpddIndex2: require('@/assets/shopping/onlineShopping/pdd/4-2.jpg'),
  branch3onlineShoppingpddIndex3: require('@/assets/shopping/onlineShopping/pdd/4-3.jpg'),
  branch3onlineShoppingpddIndex4: require('@/assets/shopping/onlineShopping/pdd/4-4.jpg'),

  onlineShoppingtbIndex2: require('@/assets/shopping/onlineShopping/tb/1-2.jpg'),
  onlineShoppingtbIndex3: require('@/assets/shopping/onlineShopping/tb/1-3.jpg'),
  onlineShoppingtbIndex4: require('@/assets/shopping/onlineShopping/tb/1-4.jpg'),
  onlineShoppingtbIndex5: require('@/assets/shopping/onlineShopping/tb/1-5.jpg'),
  onlineShoppingtbIndex6: require('@/assets/shopping/onlineShopping/tb/1-6.jpg'),
  onlineShoppingtbIndex7: require('@/assets/shopping/onlineShopping/tb/1-7.jpg'),
  onlineShoppingtbIndex8: require('@/assets/shopping/onlineShopping/tb/1-8.jpg'),
  onlineShoppingtbIndex9: require('@/assets/shopping/onlineShopping/tb/1-9.jpg'),
  onlineShoppingtbIndex10: require('@/assets/shopping/onlineShopping/tb/1-10.jpg'),
  onlineShoppingtbIndex11: require('@/assets/shopping/onlineShopping/tb/1-11.jpg'),
  onlineShoppingtbIndex12: require('@/assets/shopping/onlineShopping/tb/1-12.jpg'),
  onlineShoppingtbIndex13: require('@/assets/shopping/onlineShopping/tb/1-13.jpg'),

  branch1onlineShoppingtbIndex1: require('@/assets/shopping/onlineShopping/tb/2-1.jpg'),
  branch1onlineShoppingtbIndex2: require('@/assets/shopping/onlineShopping/tb/2-2.jpg'),
  branch1onlineShoppingtbIndex3: require('@/assets/shopping/onlineShopping/tb/2-3.jpg'),
  branch1onlineShoppingtbIndex4: require('@/assets/shopping/onlineShopping/tb/2-4.jpg'),
  branch1onlineShoppingtbIndex5: require('@/assets/shopping/onlineShopping/tb/2-5.jpg'),
  branch1onlineShoppingtbIndex6: require('@/assets/shopping/onlineShopping/tb/2-6.jpg'),

  branch2onlineShoppingtbIndex1: require('@/assets/shopping/onlineShopping/tb/3-1.jpg'),
  branch2onlineShoppingtbIndex2: require('@/assets/shopping/onlineShopping/tb/3-2.jpg'),
  branch2onlineShoppingtbIndex3: require('@/assets/shopping/onlineShopping/tb/3-3.jpg'),
  branch2onlineShoppingtbIndex4: require('@/assets/shopping/onlineShopping/tb/3-4.jpg'),
  branch2onlineShoppingtbIndex5: require('@/assets/shopping/onlineShopping/tb/3-5.jpg'),
  branch2onlineShoppingtbIndex6: require('@/assets/shopping/onlineShopping/tb/3-6.jpg'),
  branch2onlineShoppingtbIndex7: require('@/assets/shopping/onlineShopping/tb/3-7.jpg'),
  branch2onlineShoppingtbIndex8: require('@/assets/shopping/onlineShopping/tb/3-8.jpg'),

  branch3onlineShoppingtbIndex1: require('@/assets/shopping/onlineShopping/tb/4-1.jpg'),
  branch3onlineShoppingtbIndex2: require('@/assets/shopping/onlineShopping/tb/4-2.jpg'),
  branch3onlineShoppingtbIndex3: require('@/assets/shopping/onlineShopping/tb/4-3.jpg'),
  branch3onlineShoppingtbIndex4: require('@/assets/shopping/onlineShopping/tb/4-4.jpg'),

  // 微信朋友圈
  wxChatIndex1: require('@/assets/wxSettings/weChat/1-1.jpg'),
  wxChatIndex2: require('@/assets/wxSettings/weChat/1-2.jpg'),
  wxChatIndex3: require('@/assets/wxSettings/weChat/1-3.jpg'),
  wxChatIndex4: require('@/assets/wxSettings/weChat/1-4.jpg'),
  wxChatIndex5: require('@/assets/wxSettings/weChat/1-5.jpg'),
  wxChatIndex6: require('@/assets/wxSettings/weChat/1-6.jpg'),
  wxChatIndex7: require('@/assets/wxSettings/weChat/1-7.jpg'),
  wxChatIndex8: require('@/assets/wxSettings/weChat/1-8.jpg'),
  wxChatIndex9: require('@/assets/wxSettings/weChat/1-9.jpg'),
  wxChatIndex10: require('@/assets/wxSettings/weChat/1-10.jpg'),
  wxChatIndex11: require('@/assets/wxSettings/weChat/2-1.jpg'),
  wxChatIndex12: require('@/assets/wxSettings/weChat/2-2.jpg'),
  wxChatIndex13: require('@/assets/wxSettings/weChat/2-3.jpg'),
  wxChatIndex14: require('@/assets/wxSettings/weChat/2-4.jpg'),
  wxChatIndex15: require('@/assets/wxSettings/weChat/2-5.jpg'),
  wxChatIndex16: require('@/assets/wxSettings/weChat/2-6.jpg')
}
